import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAttachedCategory, LazyAttachedToOrganisation, LazyAttachedToUser, LazyCreatedDocumentFormProcess, LazyCreatedEvent, LazyCreatedEventPersonFormProcess, LazyCreatedExecutedProgram, LazyCreatedFormProcess, LazyCreatedMail, LazyCreatedProcess, LazyDeletedDocumentFormProcess, LazyDeletedEvent, LazyDeletedEventPersonFormProcess, LazyDeletedExecutedProgram, LazyDeletedFormProcess, LazyDeletedProcess, LazyDetachedCategory, LazyDetachedFromOrganisation, LazyDetachedFromUser, LazyUpdatedEvent, LazyUpdatedExecutedProgram, LazyUpdatedFormProcess, LazyUpdatedFormProcessStatus, LazyUpdatedMail, LazyUpdatedMailStatus, LazyUpdatedProcess, LazyUpdatedProcessStatus, LazyUpdatedSignature, LazyUpdatedSlNumber, LazyTableFilterBoolean, LazyTableFilterNewFilterTemplate, LazyTableFilterNumeric, LazyTableFilterProcessStatus, LazyTableFilterSearchSelect, LazyTableFilterSelect, LazyTableFilterShortcut, LazyTableFilterString, LazyTableToolCategoriesCreate, LazyTableToolFormsCreate, LazyTableToolFundingProgramsCreate, LazyTableToolGeneralExport, LazyTableToolLoginProvidersCreate, LazyTableToolMailTemplatesCreate, LazyTableToolOrganisationUsersCreate, LazyTableToolOrganisationsAttachCategory, LazyTableToolOrganisationsCreate, LazyTableToolOrganisationsToggle, LazyTableToolProcessesPaymentRuns, LazyTableToolProcessesReporting, LazyTableToolRegionsExport, LazyTableToolRegionsTokens, LazyTableToolRolesCreate, LazyTableToolStatisticSurveyPeriodsCreate, LazyTableToolStatisticSurveysCreate, LazyTableToolStatusNotificationsCreate, LazyTableToolStatusesCreate, LazyTableToolUserOrganisationsCreate, LazyTableToolUsersCreate, LazyTableToolUsersDelete, LazyTableToolYearsCreate, LazyDashboardWidgetDemoOpenAi, LazyDashboardWidgetGeneralTableIndex, LazyDashboardWidgetGeneralTableStatus, LazyFailedMail, LazySyncedDocuments, LazyBasicHeading, LazyBasicText, LazySubheading, LazyPostLoader, LazyKJPFB, LazyKJPFBR, LazyKJPKT, LazyKJPOT, LazyKJPPW, LazyKJPRM, LazyKJPTDO, LazyKVJSAAH, LazyKVJSAAJ, LazyKVJSAFB, LazyKVJSAIA, LazyKVJSVAH, LazyKVJSVAJ, LazyKVJSVFB, LazyKVJSVIA, LazyLJPA10, LazyLJPA211, LazyLJPA221, LazyLJPA221E, LazyLJPA311, LazyLJPA311BK, LazyLJPA321, LazyLJPA321BK, LazyLJPA331, LazyLJPA331BK, LazyLJPA62, LazyLJPA72, LazyLJPA82, LazyLJPV10, LazyLJPV211, LazyLJPV221, LazyLJPV311, LazyLJPV311BK, LazyLJPV321, LazyLJPV321BK, LazyLJPV331, LazyLJPV331BK, LazyLJPV62, LazyLJPV72, LazyLJPV82, LazySMPCertificates, LazySMPSubsidies, LazySZNB, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["AttachedCategory", LazyAttachedCategory],
["AttachedToOrganisation", LazyAttachedToOrganisation],
["AttachedToUser", LazyAttachedToUser],
["CreatedDocumentFormProcess", LazyCreatedDocumentFormProcess],
["CreatedEvent", LazyCreatedEvent],
["CreatedEventPersonFormProcess", LazyCreatedEventPersonFormProcess],
["CreatedExecutedProgram", LazyCreatedExecutedProgram],
["CreatedFormProcess", LazyCreatedFormProcess],
["CreatedMail", LazyCreatedMail],
["CreatedProcess", LazyCreatedProcess],
["DeletedDocumentFormProcess", LazyDeletedDocumentFormProcess],
["DeletedEvent", LazyDeletedEvent],
["DeletedEventPersonFormProcess", LazyDeletedEventPersonFormProcess],
["DeletedExecutedProgram", LazyDeletedExecutedProgram],
["DeletedFormProcess", LazyDeletedFormProcess],
["DeletedProcess", LazyDeletedProcess],
["DetachedCategory", LazyDetachedCategory],
["DetachedFromOrganisation", LazyDetachedFromOrganisation],
["DetachedFromUser", LazyDetachedFromUser],
["UpdatedEvent", LazyUpdatedEvent],
["UpdatedExecutedProgram", LazyUpdatedExecutedProgram],
["UpdatedFormProcess", LazyUpdatedFormProcess],
["UpdatedFormProcessStatus", LazyUpdatedFormProcessStatus],
["UpdatedMail", LazyUpdatedMail],
["UpdatedMailStatus", LazyUpdatedMailStatus],
["UpdatedProcess", LazyUpdatedProcess],
["UpdatedProcessStatus", LazyUpdatedProcessStatus],
["UpdatedSignature", LazyUpdatedSignature],
["UpdatedSlNumber", LazyUpdatedSlNumber],
["TableFilterBoolean", LazyTableFilterBoolean],
["TableFilterNewFilterTemplate", LazyTableFilterNewFilterTemplate],
["TableFilterNumeric", LazyTableFilterNumeric],
["TableFilterProcessStatus", LazyTableFilterProcessStatus],
["TableFilterSearchSelect", LazyTableFilterSearchSelect],
["TableFilterSelect", LazyTableFilterSelect],
["TableFilterShortcut", LazyTableFilterShortcut],
["TableFilterString", LazyTableFilterString],
["TableToolCategoriesCreate", LazyTableToolCategoriesCreate],
["TableToolFormsCreate", LazyTableToolFormsCreate],
["TableToolFundingProgramsCreate", LazyTableToolFundingProgramsCreate],
["TableToolGeneralExport", LazyTableToolGeneralExport],
["TableToolLoginProvidersCreate", LazyTableToolLoginProvidersCreate],
["TableToolMailTemplatesCreate", LazyTableToolMailTemplatesCreate],
["TableToolOrganisationUsersCreate", LazyTableToolOrganisationUsersCreate],
["TableToolOrganisationsAttachCategory", LazyTableToolOrganisationsAttachCategory],
["TableToolOrganisationsCreate", LazyTableToolOrganisationsCreate],
["TableToolOrganisationsToggle", LazyTableToolOrganisationsToggle],
["TableToolProcessesPaymentRuns", LazyTableToolProcessesPaymentRuns],
["TableToolProcessesReporting", LazyTableToolProcessesReporting],
["TableToolRegionsExport", LazyTableToolRegionsExport],
["TableToolRegionsTokens", LazyTableToolRegionsTokens],
["TableToolRolesCreate", LazyTableToolRolesCreate],
["TableToolStatisticSurveyPeriodsCreate", LazyTableToolStatisticSurveyPeriodsCreate],
["TableToolStatisticSurveysCreate", LazyTableToolStatisticSurveysCreate],
["TableToolStatusNotificationsCreate", LazyTableToolStatusNotificationsCreate],
["TableToolStatusesCreate", LazyTableToolStatusesCreate],
["TableToolUserOrganisationsCreate", LazyTableToolUserOrganisationsCreate],
["TableToolUsersCreate", LazyTableToolUsersCreate],
["TableToolUsersDelete", LazyTableToolUsersDelete],
["TableToolYearsCreate", LazyTableToolYearsCreate],
["DashboardWidgetDemoOpenAi", LazyDashboardWidgetDemoOpenAi],
["DashboardWidgetGeneralTableIndex", LazyDashboardWidgetGeneralTableIndex],
["DashboardWidgetGeneralTableStatus", LazyDashboardWidgetGeneralTableStatus],
["FailedMail", LazyFailedMail],
["SyncedDocuments", LazySyncedDocuments],
["BasicHeading", LazyBasicHeading],
["BasicText", LazyBasicText],
["Subheading", LazySubheading],
["PostLoader", LazyPostLoader],
["KJPFB", LazyKJPFB],
["KJPFBR", LazyKJPFBR],
["KJPKT", LazyKJPKT],
["KJPOT", LazyKJPOT],
["KJPPW", LazyKJPPW],
["KJPRM", LazyKJPRM],
["KJPTDO", LazyKJPTDO],
["KVJSAAH", LazyKVJSAAH],
["KVJSAAJ", LazyKVJSAAJ],
["KVJSAFB", LazyKVJSAFB],
["KVJSAIA", LazyKVJSAIA],
["KVJSVAH", LazyKVJSVAH],
["KVJSVAJ", LazyKVJSVAJ],
["KVJSVFB", LazyKVJSVFB],
["KVJSVIA", LazyKVJSVIA],
["LJPA10", LazyLJPA10],
["LJPA211", LazyLJPA211],
["LJPA221", LazyLJPA221],
["LJPA221E", LazyLJPA221E],
["LJPA311", LazyLJPA311],
["LJPA311BK", LazyLJPA311BK],
["LJPA321", LazyLJPA321],
["LJPA321BK", LazyLJPA321BK],
["LJPA331", LazyLJPA331],
["LJPA331BK", LazyLJPA331BK],
["LJPA62", LazyLJPA62],
["LJPA72", LazyLJPA72],
["LJPA82", LazyLJPA82],
["LJPV10", LazyLJPV10],
["LJPV211", LazyLJPV211],
["LJPV221", LazyLJPV221],
["LJPV311", LazyLJPV311],
["LJPV311BK", LazyLJPV311BK],
["LJPV321", LazyLJPV321],
["LJPV321BK", LazyLJPV321BK],
["LJPV331", LazyLJPV331],
["LJPV331BK", LazyLJPV331BK],
["LJPV62", LazyLJPV62],
["LJPV72", LazyLJPV72],
["LJPV82", LazyLJPV82],
["SMPCertificates", LazySMPCertificates],
["SMPSubsidies", LazySMPSubsidies],
["SZNB", LazySZNB],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
